export type ColorPalette = {
  /** Interactive accent (buttons, links, tints). Brighter in dark mode. */
  primary: string;
  primaryPressed: string;
  /** Full-bleed heroes / screen headers — stays navy in both themes. */
  brand: string;
  background: string;
  surface: string;
  border: string;
  textPrimary: string;
  textSecondary: string;
  textMuted: string;
  success: string;
  warning: string;
  error: string;
  info: string;
  /** Foreground (text/icons) on a `primary` fill. */
  onPrimary: string;
  /** Foreground on a `success` fill. */
  onSuccess: string;
  /** Foreground on an `error` fill. */
  onError: string;
  /** Foreground on a `warning` fill. */
  onWarning: string;
  /** Foreground on an `info` fill. */
  onInfo: string;
  white: string;
  black: string;
  transparent: string;
};

export const lightColors: ColorPalette = {
  primary: '#1B2A4B',
  primaryPressed: '#0F1D35',
  brand: '#1B2A4B',
  background: '#F4F6FA',
  surface: '#FFFFFF',
  border: '#D5DCE8',
  textPrimary: '#0F172A',
  textSecondary: '#475569',
  textMuted: '#5B6B80',
  success: '#15803D',
  warning: '#C2410C',
  error: '#DC2626',
  info: '#2563EB',
  onPrimary: '#FFFFFF',
  onSuccess: '#FFFFFF',
  onError: '#FFFFFF',
  onWarning: '#FFFFFF',
  onInfo: '#FFFFFF',
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
};

export const darkColors: ColorPalette = {
  primary: '#528BFF',
  primaryPressed: '#84ADFF',
  brand: '#2A5288',
  background: '#0C111D',
  surface: '#1A2234',
  border: '#3A4A66',
  textPrimary: '#F5F7FA',
  textSecondary: '#C5CDD9',
  textMuted: '#8B97A8',
  success: '#3CCB7F',
  warning: '#FDB022',
  error: '#F97066',
  info: '#84ADFF',
  // Dark-mode accents are bright, so white text on them fails contrast; use dark ink.
  onPrimary: '#0C111D',
  onSuccess: '#0C111D',
  onError: '#0C111D',
  onWarning: '#0C111D',
  onInfo: '#0C111D',
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
};

/** Default light palette used by existing screens. */
export const colors = lightColors;
